const metaDescriptions = {

  "/": {
    title: "Al Bidayah Groups | Travel, Education & Services in Malaysia",
    description:
      "Your trusted Malaysian group for travel, education, logistics, property & restaurants. Local roots, global reach.",
    keywords:
      "Al Bidayah Groups, Malaysia travel agency, overseas education Malaysia, logistics services, property Malaysia, restaurants Malaysia, travel group Kuala Lumpur, Al Bidayah Malaysia",
    robots: "index, follow",
    ogTitle: "Al Bidayah Groups | Travel, Education & Services in Malaysia",
    ogDescription:
      "Leading Malaysian group offering travel, education, logistics, property & restaurant services worldwide.",
    ogUrl: "https://www.albidayahgroups.com/",
    ogType: "website",
    ogLocale: "en_MY",
    canonicalUrl: "https://www.albidayahgroups.com/",
    twitterCard: "summary_large_image",
    twitterTitle: "Al Bidayah Groups | Travel, Education & Services in Malaysia",
    twitterDescription:
      "Local roots, global reach — Al Bidayah Groups leads Malaysia’s travel, education, logistics & restaurant sectors.",
  },
  "/about-us": {
    title: "About Al Bidayah Groups | Trusted Malaysian Business Network",
    description:
      "Discover Al Bidayah Groups – Malaysia’s leading name in travel, education, restaurants, logistics & property management.",
    keywords:
      "About Al Bidayah, Malaysian business group, Al Bidayah company profile, corporate group Malaysia, education & travel company Malaysia, logistics & property experts",
    robots: "index, follow",
    ogTitle: "About Al Bidayah Groups | Trusted Malaysian Business Network",
    ogDescription:
      "Learn about Al Bidayah Groups’ mission and growth in travel, education, logistics, and property sectors.",
    ogUrl: "https://www.albidayahgroups.com/about-us",
    ogType: "article",
    ogLocale: "en_MY",
    canonicalUrl: "https://www.albidayahgroups.com/about-us",
    twitterCard: "summary_large_image",
    twitterTitle: "About Al Bidayah Groups | Trusted Malaysian Business Network",
    twitterDescription:
      "Explore how Al Bidayah Groups became Malaysia’s trusted business network across travel, education, and logistics sectors.",
  },
  "/branches": {
    title: "Al Bidayah Branches | Our Presence Across Malaysia & Beyond",
    description:
      "Explore Al Bidayah branches across Malaysia and overseas. Expanding our network in travel, education, property & logistics.",
    keywords:
      "Al Bidayah branches, Al Bidayah Malaysia offices, global branches, travel branches Malaysia, education consultants branches, logistics network",
    robots: "index, follow",
    ogTitle: "Al Bidayah Branches | Our Presence Across Malaysia & Beyond",
    ogDescription:
      "Find our offices and global branches across Malaysia and international destinations.",
    ogUrl: "https://www.albidayahgroups.com/branches",
    ogType: "website",
    ogLocale: "en_MY",
    canonicalUrl: "https://www.albidayahgroups.com/branches",
    twitterCard: "summary_large_image",
    twitterTitle: "Al Bidayah Branches | Our Presence Across Malaysia & Beyond",
    twitterDescription:
      "Discover Al Bidayah Groups’ branch network across Malaysia and around the world — connecting education, travel, and logistics services globally.",
  },
  "/gallery": {
    title: "Al Bidayah Gallery | Travel, Education & Business Highlights",
    description:
      "View Al Bidayah Groups’ photo gallery showcasing our travel experiences, events, and business achievements in Malaysia.",
    keywords:
      "Al Bidayah gallery, photo gallery Malaysia, company events, business highlights, travel photos Malaysia, education events Malaysia",
    robots: "index, follow",
    ogTitle: "Al Bidayah Gallery | Travel, Education & Business Highlights",
    ogDescription:
      "Explore our collection of photos featuring travel, education, logistics, and restaurant achievements.",
    ogUrl: "https://www.albidayahgroups.com/gallery",
    ogType: "website",
    ogLocale: "en_MY",
    canonicalUrl: "https://www.albidayahgroups.com/gallery",
    twitterCard: "summary_large_image",
    twitterTitle: "Al Bidayah Gallery | Travel, Education & Business Highlights",
    twitterDescription:
      "Browse Al Bidayah Groups’ gallery — showcasing our milestones in travel, education, logistics, and hospitality across Malaysia.",
  },
  "/contact": {
    title: "Contact Al Bidayah Groups | Reach Our Malaysian Offices",
    description:
      "Get in touch with Al Bidayah Groups for travel, education, logistics, and property inquiries. Offices across Malaysia.",
    keywords:
      "Contact Al Bidayah, contact travel agency Malaysia, Al Bidayah contact, education consultancy Malaysia contact, logistics Malaysia office, property enquiry",
    robots: "index, follow",
    ogTitle: "Contact Al Bidayah Groups | Reach Our Malaysian Offices",
    ogDescription:
      "Connect with our team for inquiries about travel, education, property, and logistics services.",
    ogUrl: "https://www.albidayahgroups.com/contact",
    ogType: "website",
    ogLocale: "en_MY",
    canonicalUrl: "https://www.albidayahgroups.com/contact",
    twitterCard: "summary_large_image",
    twitterTitle: "Contact Al Bidayah Groups | Reach Our Malaysian Offices",
    twitterDescription:
      "Contact Al Bidayah Groups today — your trusted Malaysian partner for travel, education, property, and logistics solutions.",
  },

};

export default metaDescriptions;
